export function flag(code) {
  if (!code || code.length !== 2) return "";
  return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
}

export function fmtDate(iso, opts = { day: "2-digit", month: "short", year: "numeric" }) {
  if (!iso) return "";
  return new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-GB", opts);
}

export const STATUS_STYLE = {
  listed: "bg-stone text-charcoal", claimed: "bg-stone text-charcoal", identity_verified: "bg-gold-light text-ink",
  professionally_verified: "bg-gold text-ink", institutionally_endorsed: "bg-gold text-ink", historical: "bg-ink text-gold-light",
};

export const QUEUE_STATUS = ["pending", "under_review", "more_info", "approved", "declined", "suspended", "withdrawn"];

export function mediaUrl(src) {
  if (src && src.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return src;
}

export const NAV = [
  { to: "/", label: "Home" }, { to: "/registry", label: "Registry" }, { to: "/rankings", label: "Rankings" }, { to: "/charts", label: "Charts" }, { to: "/news", label: "News" }, { to: "/events", label: "Events" },
  { to: "/get-verified", label: "Get Verified" }, { to: "/intelligence", label: "Intelligence" }, { to: "/about", label: "About" },
];
